export const isRouteToClient = (user: User): boolean => {
  if (isUserFeature(user.role.permissions, 'user')) {
    return true
  }

  return false;
}

const isUserFeature = (arr: UserPermission[], document: string): boolean => {
  const find = arr.find((data) => data.feature.slug === document);
  if (!find) {
    return false;
  }

  return true;
}
